import { BadRequestError, BusinessError } from '@mews/framework';
import { TextKey } from '@mews/text-keys';
import { getAvailabilityBlockIdFromQuery } from '../../modules/app/selectors';
import { isMultiHotel } from '../../modules/configuration/selectors';
import {
    fetchAvailabilityBlocksFailed,
    fetchAvailabilityBlocksStarted,
    fetchAvailabilityBlocksSucceeded,
    setAvailabilityBlocks,
} from '../../modules/entities/availabilityBlocks/reducer';
import { localizeText } from '../../modules/globalization/selectors';
import { getSelectedHotelId } from '../../modules/resourceOrder/selectors';
import {
    InvalidAvailabilityBlockReason,
    isValidAvailabilityBlockWithReason,
} from '../../selectors/views/availabilityBlocks';

export const fetchAvailabilityBlockWithCheck =
    () =>
    async (dispatch: $TSFixMe, getState: $TSFixMe, { appClockService, apiService, loggerService }: $TSFixMe) => {
        const state = getState();
        const multiHotel = isMultiHotel(state);
        const availabilityBlockId = getAvailabilityBlockIdFromQuery(state);

        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (!availabilityBlockId || multiHotel) {
            return Promise.resolve();
        }

        const enterpriseId = getSelectedHotelId(state);

        try {
            dispatch(fetchAvailabilityBlocksStarted());
            const response = await apiService.getAvailabilityBlocks({
                availabilityBlockIds: [availabilityBlockId],
                enterpriseId,
            });
            dispatch(setAvailabilityBlocks(response));
        } catch (error) {
            const expiredErrorMessage = localizeText(TextKey.ExpiredReservationLinkMessage)(getState());
            const expiredError = new BusinessError(expiredErrorMessage);

            dispatch(
                // @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
                fetchAvailabilityBlocksFailed({
                    error:
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        error && (error instanceof BusinessError || error instanceof BadRequestError)
                            ? expiredError
                            : error,
                    availabilityBlockId,
                })
            );
            loggerService.log('fetch-availability-blocks-failed', 'Fetching availability blocks failed', {
                error,
                extra: { availabilityBlockId },
            });
            return;
        }

        const nowUtc = appClockService.getAppNowUtc();

        const validAvailabilityBlock = isValidAvailabilityBlockWithReason(getState(), { availabilityBlockId, nowUtc });
        if (!validAvailabilityBlock.isValid) {
            const errorTextKey =
                validAvailabilityBlock.reason === InvalidAvailabilityBlockReason.Misconfigured
                    ? TextKey.InvalidAvailabilityBlockLinkMessage
                    : TextKey.ExpiredReservationLinkMessage;
            const errorMessage = localizeText(errorTextKey)(getState());
            const error = new BusinessError(errorMessage);

            // @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
            dispatch(fetchAvailabilityBlocksFailed({ error, availabilityBlockId }));
            loggerService.log('availability-block-invalid', 'Availability block is invalid', {
                extra: { availabilityBlockId },
            });
            return;
        }

        dispatch(fetchAvailabilityBlocksSucceeded());
    };
